import moment from 'moment';

const cart = window.localStorage.getItem('cart');

const state = {
    items: cart ? JSON.parse(cart) : [],
    checkout: false,
    checkoutDate: null,
    orderType: '',
};

const getters = {
    canOrderToday(state, getters, rootState) {
        const currentTimeISO = moment().toISOString();
        const restaurantTimeUntilISO = moment(rootState.products.restaurant.order_same_date_until).toISOString();

        return moment(restaurantTimeUntilISO).isAfter(currentTimeISO);
    },

    checkoutDateIsToday(state) {
        const checkoutData = moment(state.checkoutDate);
        const today = moment();

        return checkoutData.isSame(today, 'day');
    },

    cartTotalPrice(state) {
        return state.items.reduce((total, product) => {
            let productPrice = product.price;

            if (product.dish_extras.length > 0) {
                productPrice =
                    product.dish_extras
                        .map(item => item.price)
                        .reduce((a, b) => a + b, 0) + product.price;
            }

            return total + productPrice * product.quantity;
        }, 0);
    },
};

const actions = {
    addOneToCart({ state, commit }, product) {
        const cartItem = state.items.find(item => item.id === product.id);

        commit('incrementItemQuantity', { id: cartItem.id, quantity: 1 });
        commit('saveCart');
    },

    addToCart({ state, commit }, product) {
        return new Promise((resolve) => {
            const productDishExtrasIds = product.dish_extras.filter(item => item.selected).map(item => item.id);
            const productUniqueId = product.id + productDishExtrasIds.join('-');

            const cartItem = state.items.find(item => item.id === productUniqueId);

            if (!cartItem) {
                commit('pushToCart', product);
            } else {
                commit('incrementItemQuantity', { id: cartItem.id, quantity: product.quantity });
            }
            commit('saveCart');

            resolve();
        });
    },

    emptyCart({ commit }) {
        commit('deleteCart');
    },

    substractFromCart({ state, commit }, product) {
        const cartItem = state.items.find(item => item.id === product.id);
        const index = state.items.indexOf(cartItem);

        if (cartItem.quantity === 1) {
            commit('deleteFromCart', index);
        } else {
            commit('decreaseItemQuantity', cartItem);
        }

        commit('saveCart');
    },

    removeFromCart({ state, commit }, product) {
        const cartItem = state.items.find(item => item.id === product.id);
        const index = state.items.indexOf(cartItem);

        commit('deleteFromCart', index);
        commit('saveCart');
    },

    unsetCheckout({ commit }) {
        commit('setCheckout', false);
    },
};

const mutations = {
    deleteCart() {
        window.localStorage.removeItem('cart');
    },

    decreaseItemQuantity(state, { id }) {
        const cartItem = state.items.find(item => item.id === id);
        cartItem.quantity -= 1;
    },

    deleteFromCart(state, index) {
        state.items.splice(index, 1);
    },

    incrementItemQuantity(state, { id, quantity }) {
        const cartItem = state.items.find(item => item.id === id);
        cartItem.quantity += quantity || 1;
    },

    pushToCart(state, product) {
        const productDishExtrasIds = product.dish_extras.filter(item => item.selected).map(item => item.id);
        const productUniqueId = product.id + productDishExtrasIds.join('-');

        state.items.push({
            dish_extras: productDishExtrasIds ? product.dish_extras.filter(item => item.selected) : [],
            dish_id: product.id,
            id: productUniqueId,
            name: product.name,
            price: product.price,
            quantity: product.quantity,
        });
    },

    saveCart(state) {
        window.localStorage.setItem('cart', JSON.stringify(state.items));
    },

    setOrderType(state, type) {
        state.orderType = type;
    },

    setCheckout(state, boolean) {
        state.checkout = boolean;
    },

    setCheckoutDate(state, date) {
        state.checkoutDate = date;
    },
};

export default{
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
